var _circle, _circle2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMuymal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 1,
    fill: "#1C1F20"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 14,
    r: 1,
    fill: "#1C1F20"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16ZM16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
    fill: "#1C1F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 21.2929C20.0976 21.6834 20.0976 22.3166 19.7071 22.7071C19.3199 23.0943 18.6943 23.0976 18.303 22.7171C18.3015 22.7157 18.2987 22.7132 18.2946 22.7096C18.2811 22.6978 18.2537 22.6747 18.2125 22.6437C18.13 22.5818 17.9933 22.4897 17.8028 22.3944C17.4251 22.2056 16.8272 22 16 22C15.1728 22 14.5749 22.2056 14.1972 22.3944C14.0067 22.4897 13.87 22.5818 13.7875 22.6437C13.7463 22.6747 13.7189 22.6978 13.7054 22.7096C13.7013 22.7132 13.6985 22.7157 13.697 22.7171C13.3057 23.0976 12.6801 23.0943 12.2929 22.7071C11.9024 22.3166 11.9024 21.6834 12.2929 21.2929L12.2943 21.2915L12.3278 21.2592C12.3437 21.2443 12.3639 21.2259 12.3884 21.2045C12.4373 21.1616 12.5037 21.1066 12.5875 21.0437C12.755 20.9182 12.9933 20.7603 13.3028 20.6056C13.9251 20.2944 14.8272 20 16 20C17.1728 20 18.0749 20.2944 18.6972 20.6056C19.0067 20.7603 19.245 20.9182 19.4125 21.0437C19.4963 21.1066 19.5627 21.1616 19.6116 21.2045C19.6361 21.2259 19.677 21.264 19.6929 21.2789L19.7008 21.2866L19.7041 21.2899L19.7057 21.2915L19.7071 21.2929Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMuymal);
export default __webpack_public_path__ + "static/media/Ic_Muy  mal.e628fffdd801532e2b63c6aada6e7c79.svg";
export { ForwardRef as ReactComponent };